import Shqipëria from '../images/countries/flags/al.png';
import Österreich from '../images/countries/flags/at.png';
import Bosna from '../images/countries/flags/ba.png';
import Belgique from '../images/countries/flags/be.png';
import Bulgaria from '../images/countries/flags/bg.png';
import Schweiz from '../images/countries/flags/ch.png';
import Česko from '../images/countries/flags/cz.png';
import Deutschland from '../images/countries/flags/de.png';
import Danmark from '../images/countries/flags/dk.png';
import España from '../images/countries/flags/es.png';
import France from '../images/countries/flags/fr.png';
import UK from '../images/countries/flags/gb.png';
import Greece from '../images/countries/flags/gr.png';
import Hrvatska from '../images/countries/flags/hr.png';
import Magyarország from '../images/countries/flags/hu.png';
import Ireland from '../images/countries/flags/ie.png';
import Ísland from '../images/countries/flags/is.png';
import Italia from '../images/countries/flags/it.png';
import Luxembourg from '../images/countries/flags/lu.png';
import Maroc from '../images/countries/flags/ma.png';
import Montenegro from '../images/countries/flags/me.png';
import Macedonia from '../images/countries/flags/mk.png';
import Nederland from '../images/countries/flags/nl.png';
import Norge from '../images/countries/flags/no.png';
import Polska from '../images/countries/flags/pl.png';
import Portugal from '../images/countries/flags/pt.png';
import România from '../images/countries/flags/ro.png';
import Serbia from '../images/countries/flags/rs.png';
import Sverige from '../images/countries/flags/se.png';
import Slovenija from '../images/countries/flags/si.png';
import Slovensko from '../images/countries/flags/sk.png';
import Ukraine from '../images/countries/flags/ua.png';

const flags = {
  France,
  Belgique,
  Bosna,
  Bulgaria,
  Česko,
  Danmark,
  Deutschland,
  España,
  Greece,
  Hrvatska,
  Ireland,
  Italia,
  Ísland,
  Lëtzebuerg: Luxembourg,
  Luxembourg,
  Macedonia,
  Magyarország,
  Maroc,
  Montenegro,
  Nederland,
  Norge,
  Österreich,
  Polska,
  Portugal,
  România,
  Schweiz,
  Serbia,
  Shqipëria,
  Slovenija,
  Slovensko,
  Sverige,
  Ukraine,
  'United Kingdom': UK,
};

const getFlag = (name) => flags[name];

export default getFlag;
